import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import AIForLeaders from "@/components/AIForLeaders";
import AILyftet from "@/components/AILyftet";
import AIMasterclass from "@/components/AIMasterclass";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const AISkilling = () => {
  return (
    <>
      <SeoHead
        title="AI-skilling Programs | AI-labbet"
        description="AI training programs for leaders and teams. Build AI capabilities with our comprehensive skilling courses and masterclasses."
        path="/ai-skilling"
      />
      
      <div className="min-h-screen bg-background">
        <Header />
        <PageBreadcrumb currentPage="AI-skilling" />
        
        <main>
          <AIForLeaders />
          <AILyftet />
          <AIMasterclass />
          
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default AISkilling;
